module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-1600px-dark-theme-7750441df8a1b0e059821e87b7ff9f47.jpg";